// MpCard — cartão base com borda sutil, raio 12, cabeçalho com título
// (16/600) e ação opcional à direita. Não substitui cartões existentes.
import React from "react";
import { colors, radii } from "./tokens";

export default function MpCard({ title, action, children, padding = 16, testId }) {
  return (
    <section
      data-testid={testId}
      style={{
        background: colors.branco,
        border: `1px solid ${colors.neutro[300]}`,
        borderRadius: radii.card,
        padding,
      }}
    >
      {(title || action) ? (
        <header style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          marginBottom: 12,
        }}>
          {title ? <h3 style={{ fontSize: 16, fontWeight: 600, color: colors.marinho, margin: 0 }}>{title}</h3> : <div />}
          {action ? <div>{action}</div> : null}
        </header>
      ) : null}
      {children}
    </section>
  );
}
